export default class Timer {
  static tmod: number = 1;
}
